import React from 'react';

const Title = () => {
  return (
    <div className="title">
      <h1>Your Photo Space</h1>
      <h2>Your Gallery</h2>
      <p>Hope you like this project and share your views with <a href="mailto:prakharsharma22@gmail.com">me</a></p>
    </div>
  )
}

export default Title;